function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { graphql } from "@oui/lib/src/graphql/tada";
import { CurrentUserQuery } from "../hooks/useCurrentUser";
var FabricateStateV2EndMutation = graphql("\n  mutation FabricateStateV2End($content: ContentType!) {\n    setOuiProgress(content: $content, value: 1) {\n      content\n      completion\n      completed\n      updatedAt\n    }\n  }\n");
export function mockConversationCompleteV2(client, convoID) {
    return client.mutate({
        mutation: FabricateStateV2EndMutation,
        variables: {
            content: convoID
        },
        update: function(cache, result) {
            var _query_user_role, _query_user;
            if (!result.data) return;
            var query = cache.readQuery({
                query: CurrentUserQuery
            });
            var patientID = query === null || query === void 0 ? void 0 : (_query_user = query.user) === null || _query_user === void 0 ? void 0 : (_query_user_role = _query_user.role) === null || _query_user_role === void 0 ? void 0 : _query_user_role.ID;
            var key = cache.identify({
                __typename: 'PatientProfile',
                patient: {
                    ID: patientID
                }
            });
            cache.modify({
                id: key,
                fields: {
                    ID: function(id) {
                        return id;
                    },
                    // @ts-expect-error apollo types changed in 3.8.x and are no longer happy with us
                    // specifying the type of existingProgress. At some point should circle back and
                    // figure out how to type this properly
                    progress: function() {
                        var existingProgress = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                        if (!result.data) return existingProgress;
                        var progress = existingProgress.filter(function(p) {
                            return p.content !== convoID;
                        });
                        return _to_consumable_array(progress).concat([
                            result.data.setOuiProgress
                        ]);
                    }
                }
            });
        }
    });
}
